import { getPaymentDates } from './PaymentDates';

export function consolidateCartPayments(cart) {
  const consolidatedPayments = {
    firstPayment: 0,
    otherPayments: [],
  };

  let totalRemainingBalance = 0;
  let maxInstallments = 0;
  let selectedPaymentPlan = null;
  let paymentPlan = null;

  // Step 1: Calculate first payment and total remaining balance
  cart.forEach((item) => {
    const cartPaymentPlan = item?.selectedPaymentPlan || item?.paymentPlan;
    const options = item?.paymentOptionsBreakdown || [];

    selectedPaymentPlan = item?.selectedPaymentPlan;
    paymentPlan = item?.paymentPlan;

    // Detect if this product only supports full payment
    const hasOnlyFullPayment =
      options.length === 1 && options[0]?.type === 'full';

    if (hasOnlyFullPayment) {
      // Add full payment to firstPayment directly
      consolidatedPayments.firstPayment +=
        (Number(item.price) || 0) * (item?.quantity || 1);
      return;
    }

    // Find the selected payment plan details
    const option = options.find((opt) => opt?.type === cartPaymentPlan);
    if (!option) return;

    // Calculate down payment
    const downPayment = (option?.downPayment || 0) * (item?.quantity || 1);
    consolidatedPayments.firstPayment += downPayment;

    // Determine number of installments
    const installmentsCount =
      option.numberOfInstallments ||
      option.months ||
      option.weeks ||
      option.days ||
      0;

    if (installmentsCount > maxInstallments) {
      maxInstallments = installmentsCount;
    }

    // Add to total remaining balance (excluding down payment)
    const totalInstallmentsAmount =
      (option.installmentAmount || 0) *
      installmentsCount *
      (item?.quantity || 1);

    totalRemainingBalance += totalInstallmentsAmount;
  });

  // Step 2: If there are installments, distribute remaining balance
  if (maxInstallments > 0) {
    const fixedInstallmentAmount = totalRemainingBalance / maxInstallments;

    //  Correct getPaymentDates call
    const paymentDates = getPaymentDates(
      selectedPaymentPlan,
      paymentPlan,
      new Date(), // start date
      maxInstallments
    );

    for (let i = 0; i < maxInstallments; i++) {
      consolidatedPayments.otherPayments.push({
        amount: fixedInstallmentAmount,
        date: paymentDates[i],
      });
    }
  }

  return consolidatedPayments;
}
